<template>
  <div class="brand-detection">
    <el-dialog
      :show-close="true"
      :visible.sync="originalVideoModal.open"
      width="1119px">
      <div class="close-video" @click="originalVideoModal = { open: false, src: '' }">
        <svgicon name="Close"></svgicon>
      </div>
      <video :src="originalVideoModal.src" controls></video>
    </el-dialog>
    <pdf
      v-if="project && pdfGeneration"
      :report="summaryReport"
      :name="project.project_name + '.pdf'"
      :project="project"
      @generated="pdfGeneration = false"/>
    <single-pdf
      v-if="project && singlePagePdfGeneration"
      :name="project.project_name + '.pdf'"
      :video="videoToPdf"
      @generated="singlePagePdfGeneration = false"/>
    <div class="loader-container">
      <BaseLoader v-if="loading || downloading || pdfGeneration || singlePagePdfGeneration" />
    </div>
    <div class="brand-detection__header" v-if="project">
      <div class="brand-detection__header-name">
        <svgicon name="Bar-chart"></svgicon>
        <h1 class="acr-bold-18">{{project.project_name}}</h1>
      </div>
      <div class="brand-detection__header-name">
        <div class="brand-detection__header-tab" @click="activeTab = 'Report'"
             :class="{'active': activeTab === 'Report'}">
          <svgicon name="Report-chart"></svgicon>
          <span>Report</span>
        </div>
        <div class="brand-detection__header-tab" :class="{'active': activeTab === 'Timeline'}" @click="activeTab = 'Timeline'">
          <svgicon name="Clock"></svgicon>
          <span>Timeline</span>
        </div>
        <div class="brand-detection__header-tab mr-30" :class="{'active': activeTab === 'Heatmap'}" @click="activeTab = 'Heatmap'">
          <svgicon name="Heatmap"></svgicon>
          <span>Heatmap</span>
        </div>
        <div class="brand-detection__header-info">
          <svgicon name="Info"></svgicon>
        </div>
      </div>
    </div>
    <div class="brand-detection__header brand-detection__nav" v-if="project && processedVideos">
      <div class="brand-detection__header-name">
        <div class="brand-detection__header-tab"
             v-if="activeTab !== 'Timeline'"
             :class="{'active': intersectingCard === 'sum'}">
          <svgicon name="Brand-sum"></svgicon>
          <a href="#" @click.prevent="smoothScroll('sum')"><span>Summary</span></a>
        </div>
        <div class="brand-detection__header-tab"
             v-for="item in processedVideos"
             :key="item.id + 'tab'"
             :class="{'active': intersectingCard === `${item.id}`}">
          <svgicon name="Brand-video"></svgicon>
          <a href="#" @click.prevent="smoothScroll(item.id)"><span>{{trunc(item.display_name)}}</span></a>
        </div>
      </div>
      <el-button class="action-button" @click="openSettings">
        <svgicon name="Setting" />
      </el-button>
      <el-select size="small" placeholder="Select brands" popper-class="select-popper" style="width: 260px;" :value="Object.keys(this.brands).filter((key) => !!this.brands[key]).join(', ')">
        <el-option v-for="v in Object.keys(brands)" :key="v" value="1">
          <el-checkbox @change="onFilterSelect($event, v)" :value="brands[v]"><span class="acr-medium">{{v}}</span>
          </el-checkbox>
        </el-option>
      </el-select>
    </div>
    <div v-if="activeTab === 'Report'" class="content-wrapper brand-detection__content" ref="container">

      <div class="brand-detection__card summary" ref="sum" data-attr="sum">
        <div class="brand-detection__card-header">
          <div class="brand-detection__card-btns">
            <el-dropdown trigger="hover" @command="download($event, `(${project.project_name})`)">
              <div class="brand-detection__card-export">
                <span style="margin-top: -2px">Export</span>
                <div class="brand-detection__card-export-select">
                  <svgicon name="ArrowDown"></svgicon>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="pdf">PDF</el-dropdown-item>
                <el-dropdown-item command="zip">ZIP</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
          <div class="brand-detection__card-info">
            <div class="brand-detection__card-title acr-bold-22">{{ allVideosTitle }}</div>
          </div>
        </div>
        <chart-list
          :brands-list="summaryReport"
          :series="summarySeries" />
      </div>

      <div class="brand-detection__card" :data-attr="video.id" :ref="video.id" v-for="video in processedVideos"
           :key="video.id">
        <div class="brand-detection__card-header">
          <div class="brand-detection__card-video" @click="originalVideoModal = { open: true, src: video.original_video_url }">
            <div class="brand-detection__card-video-overlay">
              <svgicon name="Play" class="brand-detection__card-video-play"></svgicon>
            </div>
            <img :src="video.thumbnail_url" alt="" class="brand-detection__card-video-src">
          </div>
          <video-actions
            :video="video"
            @download="download"
            @settings="openSettings" />
          <video-info :video="video" />
        </div>
        <chart-list
          :brands-list="video.report"
          :series="videosSeries[video.id]" />
      </div>
      <SmallFooter></SmallFooter>
    </div>
    <div v-if="activeTab === 'Timeline'" class="content-wrapper brand-detection__content brand-detection__timeline">
      <div class="brand-detection__card" v-for="video in processedTimelines" :key="video.id" :data-attr="video.id" :ref="video.id">
        <div class="brand-detection__card-header">
          <div class="brand-detection__card-video" @click="originalVideoModal = { open: true, src: video.original_video_url }">
            <div class="brand-detection__card-video-overlay">
              <svgicon name="Play" class="brand-detection__card-video-play"></svgicon>
            </div>
            <img :src="video.thumbnail_url" alt="" class="brand-detection__card-video-src">
          </div>
          <video-actions
            :video="video"
            @download="download"
            @settings="openSettings" />
          <video-info :video="video" />
        </div>
        <div class="brand-detection__card-data block" :data-attr="video.id" :ref="video.id">
          <div style="width: 100%" v-for="item in video.timelines" :key="item.brand">
            <h4 class="acr-bold">{{item.brand}}</h4>
            <apexchart height="210" type="area" :options="areaOptions" :series="[{ data: item.data.map(i => ({...i, y: i.y ? Math.round(i.y * 100) > 1 ? i.y.toFixed(2) : '0.01': '0.00'})) }]"></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeTab === 'Heatmap'" class="content-wrapper brand-detection__content">
      <div class="brand-detection__card summary" data-attr="sum" ref="sum">
        <div class="brand-detection__card-header" style="margin-bottom: 0">
          <div class="brand-detection__card-btns">
            <el-dropdown trigger="hover" @command="download($event, `(${project.project_name})`, video)">
              <div class="brand-detection__card-export">
                <span style="margin-top: -2px">Export</span>
                <div class="brand-detection__card-export-select">
                  <svgicon name="ArrowDown"></svgicon>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="pdf">PDF</el-dropdown-item>
                <el-dropdown-item command="csv">CSV</el-dropdown-item>
                <el-dropdown-item command="zip">ZIP</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="brand-detection__card-info">
            <div class="brand-detection__card-title acr-bold-22">{{ allVideosTitle }}</div>
          </div>
        </div>


        <div class="brand-detection__card-data" ref="sum" data-attr="sum" >
          <section class="mt-45 heatmap-container">
            <div class="heatmap" v-for="(item, index) in heatmapSummary" :key="item.brand + index">
              <div class="content-heading">
                <span class="acr-bold">{{item.brand}}</span>
                <!--<span>8.1%</span>-->
              </div>
              <img :src="item.heatmap_url" alt="" class="heatmap-img">
            </div>
          </section>
        </div>
      </div>
      <div class="brand-detection__card" v-for="video in processedHeatmaps" :key="video.id" :data-attr="video.id" :ref="video.id">
        <div class="brand-detection__card-header">
          <div class="brand-detection__card-video" @click="originalVideoModal = { open: true, src: video.original_video_url }">
            <div class="brand-detection__card-video-overlay">
              <svgicon name="Play" class="brand-detection__card-video-play"></svgicon>
            </div>
            <img :src="video.thumbnail_url" alt="" class="brand-detection__card-video-src">
          </div>
          <video-actions
            :video="video"
            @download="download"
            @settings="openSettings" />
          <video-info :video="video" />
        </div>

        <div class="brand-detection__card-data" :ref="video.id" :data-attr="video.id" >
          <section class="mt-45 heatmap-container">
            <div class="heatmap" v-for="(item, index) in video.heatmaps" :key="item.brand + index">
              <div class="content-heading">
                <span class="acr-bold">{{item.brand}}</span>
                <!--<span>8.1%</span>-->
              </div>
              <img :src="item.heatmap_url" alt="" class="heatmap-img">
            </div>
          </section>
        </div>
      </div>
    </div>
    <project-settings
      ref="settings"
      :project="project || {}"
      :videos-info="processedVideos"
      @update="updateProjectInfo" />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import {getProjectById,
    getProjectReport,
    getProjectSettings,
    downloadProjectReport,
    rerunProject,
    duplicateProject,
    getProjectHeatmap,
    getProjectTimeline
  } from "../../api/projects";
  import ChartList from './componenets/ChartList';
  import ProjectSettings from './componenets/ProjectSettings';
  import SmallFooter from '../../components/footer/SmallFooter';
  import BaseLoader from '../../components/BaseLoader';
  import pdf from '../../views/pdf';
  import singlePdf from '../../views/pdf/single-pdf';
  import VideoActions from './componenets/VideoActions';
  import VideoInfo from './componenets/VideoInfo';

  export default {
    name: "BrandDetectionReport",
    components: {ChartList, ProjectSettings, SmallFooter, BaseLoader, pdf, singlePdf, VideoActions, VideoInfo},
    data() {
      return {
        originalVideoModal: {
          open: false,
          src: ''
        },
        pdfGeneration: false,
        singlePagePdfGeneration: false,
        videoToPdf: null,
        loading: true,
        showFilter: false,
        downloading: false,
        brands: {},
        timelineVideos: null,
        heatmapVideos: null,
        heatmapSummary: null,
        video: null,
        project: null,
        rerenderFilters: 0,
        observer: null,
        intersectingCard: 'sum',
        sorting: '',
        tabs: [
          'Report',
          'Timeline',
          'Heatmap'
        ],
        activeTab: 'Report',
        areaOptions: {
          chart: {
            type: 'area',
            width: '100%',
            toolbar: {
              show: false,
            },
            zoom: {enabled: false},
            parentHeightOffset: 0,

          },
          grid: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            },
            xaxis: {
              lines: {
                show: true
              }
            },
            yaxis: {
              lines: {
                show: true
              },
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'stepline',
            colors: ['#577590'],
            width: 1
          },
          fill: {
            colors: ['#577590']
          },
          xaxis: {
            position: 'top',
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
            labels: {
              offsetX: -4.5,
              align: 'center',
              style: {
                fontSize: '10px',
                marginBottom: '9px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
            },

          },
          yaxis: {
            opposite: true,
            axisBorder: {
              show: false
            },
            labels: {
              offsetX: -4.5,
              offsetY: 3.5,
              align: 'right',
              style: {
                fontSize: '10px',
                marginBottom: '9px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
              },
            },
          },
        },
        areaSeries: [{
          data: [34, 44, 54, 21, 12, 43, 33, 23, 66, 66, 58]
        }],
      }
    },
    watch: {
      activeTab(v) {
        if (v === 'Report') {
          this.$nextTick(() => {
            this.smoothScroll('sum');
            this.observer.observe(this.$refs.sum);
            this.intersectingCard = 'sum';
          })
        }
      }
    },
    computed: {
      allVideosTitle() {
        return `Summary of ${this.processedVideos.length} videos:`
      },
      projectId() {
        return this.$route.params.projectId;
      },
      videosSeries() {
        return this.processedVideos.reduce((res, cur) => {
          const temp = { ...this.getSeries(cur.report) };
          if (temp.brand_value[0].data.every(el => el <= 0)) {
            temp.brand_value = {
              action: () => this.openSettings(null, cur.id),
              empty: true,
              label: 'Broadcast prices are not selected for this video',
            };
          }
          res[cur.id] = temp;
          return res;
        }, {});
      },
      summarySeries() {
        const temp = { ...this.getSeries(this.summaryReport) };
        if (temp.brand_value[0].data.every(el => el <= 0)) {
          temp.brand_value = {
            action: this.openSettings,
            empty: true,
            label: 'Broadcast prices are not selected for all videos',
          };
        }
        return temp;
      },
      summaryReport() {
        if (!this.project) return [];

        const filterApplied = Object.keys(this.brands).filter((key) => !!this.brands[key]);

        if (filterApplied.length === 0) return this.project.summary_report;
        return this.project.summary_report.filter((item) => this.brands[item.brand]);
      },
      processedVideos() {
        if (!this.project) return [];

        const filterApplied = Object.keys(this.brands).filter((key) => !!this.brands[key]);

        if (filterApplied.length === 0) return this.project.videos;

        return this.project.videos.map((video) => {
          return {...video, report: video.report.filter((item) => this.brands[item.brand])}
        });
      },
      processedTimelines() {
        if (!this.project || !this.timelineVideos) return [];

        const filterApplied = Object.keys(this.brands).filter((key) => !!this.brands[key]);

        if (filterApplied.length === 0) return this.timelineVideos;

        return this.timelineVideos.map((video) => {
          return {...video, timelines: video.timelines.filter((item) => this.brands[item.brand])}
        });
      },
      processedHeatmaps() {
        if (!this.project || !this.heatmapVideos) return [];

        const filterApplied = Object.keys(this.brands).filter((key) => !!this.brands[key]);

        if (filterApplied.length === 0) return this.heatmapVideos;

        return this.heatmapVideos.map((video) => {
          return {...video, heatmaps: video.heatmaps.filter((item) => this.brands[item.brand])}
        });
      },
      filterApplied() {
        return Object.keys(this.brands).filter((key) => !!this.brands[key]).length
      },
    },
    created() {
      this.areaSeries[0].data = Array.from({length: 20}, () => {
        return {x: '00:' + Math.floor(Math.random() * 40), y: Math.floor(Math.random() * 40)}
      });
    },
    mounted() {
      this.observer = new IntersectionObserver(this.onElementObserved, {root: this.$el, threshold: [0.75]});

      this.getProjectInfo();

      getProjectTimeline(this.$route.params.projectId).then((res) => {
        this.timelineVideos = res.data.videos
      });

      getProjectHeatmap(this.$route.params.projectId).then((res) => {
        this.heatmapVideos = res.data.videos
        this.heatmapSummary = res.data.summary
      });
    },
    beforeDestroy() {
      this.observer.disconnect();
    },
    methods: {
      ...mapActions({
        success: 'success',
      }),
      async getProjectInfo() {
        const [{ data: project }, { data: settings }] = await Promise.all([
          getProjectById(this.projectId),
          getProjectSettings(this.projectId),
        ]);
        const brandsInstances = project.summary_report.map(item => item.brand);
        this.brands = brandsInstances.reduce((acc, curr) => (acc[curr] = true, acc), {});
        this.project = {
          ...project,
          videos: project.videos.map(el => {
            const details = settings.videos.find(({ video_id }) => video_id === el.id);
            const priceInfo = details ? details : {
              video_id: el.id,
              video_name: el.video_name,
            };
            return {
              ...el,
              priceSettings: {
                ...priceInfo,
                symbol: project.currency_symbol,
              },
            }
          }),
        };
        this.loading = false;

        this.$nextTick(() => {
          this.observer.observe(this.$refs.sum);
          this.project.videos.forEach(v => this.observer.observe(this.$refs[v.id][0]));
        });
      },
      onElementObserved(entries) {
        entries.forEach(({target, isIntersecting}) => {
          if (!isIntersecting) {
            return;
          }

          this.intersectingCard = target.getAttribute("data-attr");
        });
      },
      openSettings(_, id) {
        this.$refs.settings.setInitial(id);
        this.$refs.settings.open();
      },
      smoothScroll(ref) {
        const el = ref === 'sum' ? this.$refs.sum : this.$refs[ref][0];
        el.scrollIntoView({
          behavior: 'smooth'
        })
      },
      trunc(str) {
        return str.length >= 15 ? str.substring(0, 20) + '...' : str;
      },
      getHiddenOptionsWithHiddenXAxis(options) {
        const optionsCopy = JSON.parse(JSON.stringify(options));
        optionsCopy.xaxis.labels.show = false;
        return optionsCopy
      },
      onFilterSelect(value, filter) {
        this.brands = {
          ...this.brands,
          [filter]: value
        };
      },
      clearFilters() {
        Object.keys(this.brands).forEach((key) => this.brands[key] = false);
        this.rerenderFilters += 1;
      },
      download(command, fileName, video) {
        if (command === 'pdf') {
          // if (video && video.id) {
          //   this.videoToPdf = video;
          //   this.singlePagePdfGeneration = true;
          // } else {
          //   this.pdfGeneration = true;
          // }
          this.downloading = true;
          const reportType = 'aggregated';
          getProjectReport(this.$route.params.projectId, video ? video.id : '', reportType).then((data) => {
            this.downloading = false;
            downloadProjectReport(data.data, fileName + '.pdf', 'application/pdf')
          });
        } else if (command === 'zip') {
          this.downloading = true;
          const reportType = 'zip';
          getProjectReport(this.$route.params.projectId, video ? video.id : '', reportType).then((data) => {
            this.downloading = false;
            downloadProjectReport(data.data, fileName + '.zip', 'application/zip')
          });
        } else {
          this.downloading = true;
          const reportType = 'detailed';
          getProjectReport(this.$route.params.projectId, video.id, reportType).then((data) => {
            this.downloading = false;
            downloadProjectReport(data.data, fileName + '.csv', 'application/csv')
          });
        }
      },
      rerun() {
        rerunProject(this.$route.params.projectId).then(() => {
          this.$router.push({name: 'projects'})
        })
      },
      duplicate_project() {
        duplicateProject(this.$route.params.projectId).then(() => {
          this.$router.push({ name: 'projects' })
        })
      },
      getSeries(report) {
        return {
          bis: [{name: 'bis', data: [...report.map(i => i.bis.toFixed(4))]}],
          brand_value: [{name: 'brand value', data: [...report.map(i => Math.round(i.brand_value))]}],
          exposureS: [{name: 'exposure, s', data: [...report.map(i => `${i.exposure_time_sec} (${i.exposure_time_pct}%)`)]}],
        }
      },
      async updateProjectInfo() {
        await this.getProjectInfo();
        this.success('Changes have been made to this project');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .pdf-generator-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }
</style>
